import {
  acceptInvite,
  declineInvite,
} from '@lib/api/client/respond-to-organization-invite';
import { openSnackbar } from '@ui/Dallas/Snackbar/DallasSnackbarService';
import { useCallback, useState } from 'react';
import {
  getAcceptSnackbarSubheaderText,
  getDeclineSnackbarSubheaderText,
} from './copy';
import useOrganizationInviteSessionStorage from './useOrganizationInviteSessionStorage';

export default function useRespondToOrganizationInvite(secureToken: string) {
  const [didError, setDidError] = useState(false);
  const [didSucceed, setDidSucceed] = useState(false);
  const { reset: resetSessionStorage } = useOrganizationInviteSessionStorage();

  const accept = useCallback(async () => {
    const invite = await acceptInvite(secureToken);
    if (invite.status !== 'accepted') {
      setDidError(true);
      return;
    }
    openSnackbar({
      color: 'success',
      header: 'Welcome to the team!',
      subheader: getAcceptSnackbarSubheaderText(invite),
    });
    resetSessionStorage();
    setDidSucceed(true);
  }, [resetSessionStorage, secureToken]);

  const decline = useCallback(async () => {
    const invite = await declineInvite(secureToken);
    if (invite.status !== 'declined') {
      setDidError(true);
      return;
    }
    openSnackbar({
      color: 'default',
      header: 'You declined the invite',
      subheader: getDeclineSnackbarSubheaderText(invite),
    });
    resetSessionStorage();
    setDidSucceed(true);
  }, [resetSessionStorage, secureToken]);

  return { accept, decline, didError, didSucceed };
}
